export const getSSHKeyColumns = (
  t: (key: string) => string,
  showStatusColumn = false,
  showTypeColumn = true,
) => {
  const columns = [
    {
      id: 'keyName',
      label: t('table.keyName'),
    },
    {
      id: 'added',
      label: t('table.added'),
    },
    {
      id: 'actions',
      label: t('table.actions'),
    },
  ];

  if (showTypeColumn) {
    columns.splice(1, 0, {
      id: 'alg_type',
      label: t('table.type'),
    });
  }

  if (showStatusColumn) {
    columns.splice(showTypeColumn ? 2 : 1, 0, {
      id: 'status',
      label: t('table.status'),
    });
  }

  return columns;
};
